import React from 'react';
import Container from 'components/Container';
import Main from 'layouts/Main';
import { useTranslation } from 'react-i18next';
import { VerticallyAlignedBlogCardsWithShapedImage } from './components';
import SEO from 'components/SEO';
import useCertificateData from 'Hooks/useCertificateData';

const Certificates = () => {
  const { t } = useTranslation();
  const {
    data: certificateData = [],
    error,
    execute,
  } = useCertificateData('certificate');

  return (
    <Main>
      <SEO
        title={t('seo.certificates.title')}
        description={t('seo.certificates.description')}
        keywords={t('seo.certificates.keywords')}
        url="/certificates"
      />
      <Container>
        <VerticallyAlignedBlogCardsWithShapedImage
          certificateData={certificateData}
          error={error}
          onRetry={() => execute()}
          filterCategory="batter"
        />
      </Container>
    </Main>
  );
};

export default Certificates;
